import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var ParkingIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M19 2a3 3 0 013 3v14a3 3 0 01-3 3H5a3 3 0 01-3-3V5a3 3 0 013-3h14zm0 2H5a1 1 0 00-1 1v14a1 1 0 001 1h14a1 1 0 001-1V5a1 1 0 00-1-1zm-6.45 2.5c1.21 0 2.16.285 2.85.855.69.57 1.035 1.4 1.035 2.49 0 1.08-.345 1.897-1.035 2.452-.69.556-1.64.833-2.85.833h-2.205v3.51a.34.34 0 01-.105.262.381.381 0 01-.27.098H8.53a.347.347 0 01-.255-.105.347.347 0 01-.105-.255V6.875c0-.11.032-.2.098-.27A.34.34 0 018.53 6.5h4.02zm-.075 1.68h-2.16v3.27h2.16c.58 0 1.022-.137 1.328-.412.305-.276.457-.678.457-1.208 0-.52-.147-.925-.442-1.215-.296-.29-.743-.435-1.343-.435z",
                        fillRule: "nonzero"
                    })
                })
            })
        ]
    });
};
ParkingIcon.isCarinaIcon = true;
export default ParkingIcon;
